import React from 'react';
import Applicants from './applicants';


function Maincontentbottom() {
  return (
    <div className="main-content-bottom">
        <Applicants/>
    </div>
  );
}

export default Maincontentbottom;
